<template>
  <div class="giveaway-oops">
    <h2 class="giveaway-oops__heading heading--3">
      Oops!
    </h2>
    <p class="giveaway-oops__copy">It looks like you've already entered.  Winner(s) will be notified via email.</p>
    <a
      v-if="showGiveawayDetailsLink"
      :href="giveawayDetails"
      target="_blank"
      class="giveaway-oops__cta"
    >
      View giveaway details
      <icon-component
        name="caret"
        title="caret icon"
        class="giveaway-oops__icon icon--small"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'GiveawayOops',
  props: {
    giveawayDetails: {
      type: String,
      required: true,
    },
  },
  computed: {
    showGiveawayDetailsLink() {
      return window.location.href !== this.giveawayDetails;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/stylesheets/components/_giveaway-oops';
</style>
